import React from 'react'
import {connectStats} from 'react-instantsearch-dom'

const Stats = ({processingTimeMS, nbHits, nbSortedHits, areHitsSorted}) => (
  <span>{nbHits.toLocaleString()} resultater</span>
)

export default connectStats(Stats)
